import {
  useEffect,
  useRef,
  useState,
} from 'react';

import {
  ChevronDown,
  Search,
} from 'lucide-react';

type Props = {
  value: string;
  options: string[];
  onChange: (
    value: string,
  ) => void;
};

const DepartmentDropdown = ({
  value,
  options,
  onChange,
}: Props) => {
  const [isOpen, setIsOpen] =
    useState(false);

  const [search, setSearch] =
    useState('');

  const dropdownRef =
    useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (
      event: MouseEvent,
    ) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(
          event.target as Node,
        )
      ) {
        setIsOpen(false);
        setSearch('');
      }
    };

    document.addEventListener(
      'mousedown',
      handleClickOutside,
    );

    return () =>
      document.removeEventListener(
        'mousedown',
        handleClickOutside,
      );
  }, []);

  const filteredOptions =
    options.filter((item) =>
      item
        .toLowerCase()
        .includes(
          search.toLowerCase(),
        ),
    );

  return (
    <div
      ref={dropdownRef}
      className="relative w-[180px]"
    >
      <button
        type="button"
        onClick={() =>
          setIsOpen(
            (prev) => !prev,
          )
        }
        className="
          flex
          h-[34px]
          w-full
          items-center
          justify-between
          rounded-md
          border
          border-[#D0D5DD]
          bg-white
          px-3
          text-[12px]
          text-[#344054]
          hover:border-[#98A2B3]
        "
      >
        <span className="truncate">
          {value}
        </span>

        <ChevronDown
          size={14}
          className={`transition-transform ${
            isOpen
              ? 'rotate-180'
              : ''
          }`}
        />
      </button>

      {isOpen && (
        <div
          className="
            absolute
            left-0
            top-full
            z-50
            mt-1
            w-full
            rounded-md
            border
            border-[#EAECF0]
            bg-white
            shadow-lg
          "
        >
          <div className="p-2">
            <div className="relative">
              <Search
                size={12}
                className="
                  absolute
                  left-2
                  top-1/2
                  -translate-y-1/2
                  text-[#667085]
                "
              />

              <input
                type="text"
                placeholder="Search..."
                value={search}
                onChange={(e) =>
                  setSearch(
                    e.target.value,
                  )
                }
                className="
                  h-[30px]
                  w-full
                  rounded-md
                  border
                  border-[#D0D5DD]
                  pl-7
                  pr-2
                  text-[12px]
                  outline-none
                  focus:border-[#002B5B]
                "
              />
            </div>
          </div>

          <div className="max-h-[180px] overflow-y-auto">
            {filteredOptions.length >
            0 ? (
              filteredOptions.map(
                (item) => (
                  <button
                    key={item}
                    type="button"
                    onClick={() => {
                      onChange(item);
                      setIsOpen(
                        false,
                      );
                      setSearch(
                        '',
                      );
                    }}
                    className={`
                      w-full
                      px-3
                      py-2
                      text-left
                      text-[12px]
                      hover:bg-[#F9FAFB]
                      ${
                        value ===
                        item
                          ? 'bg-[#EEF4FF] text-[#002B5B] font-medium'
                          : 'text-[#344054]'
                      }
                    `}
                  >
                    {item}
                  </button>
                ),
              )
            ) : (
              <div
                className="
                  py-3
                  text-center
                  text-[12px]
                  text-[#98A2B3]
                "
              >
                No results found
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DepartmentDropdown;